import { useState } from "react";
import { Box } from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CommentsManagementGrid from "./CommentsManagementGrid";
import OperatorsManage from "./OperatorsManage";

export default function CommentsManagement(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [refesh, setRefesh] = useState(false);

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/managecomments" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <CommentsManagementGrid refesh={refesh} setRefesh={setRefesh} />
        <OperatorsManage callBack={() => setRefesh(true)} />
      </Box>
    </Detail>
  );
}
